/**
 * Точка входа webpack: landing.main
 */
import './main.css';
import '../../common.js';
import '../../modules/partners/partners.js';
import '../../modules/demo/demo.js';
import { initLandingVideo } from '../../modules/video/video.js';
import '../../modules/easy_start/easy_start.js';
import { initReviews } from '../../modules/reviews/reviews.js';

const SEARCH_LENGTH_LOAD_DATA = 4;
const SEARCH_DELAY_LOAD_DATA = 500;
const TRY_SCROLL_EXTRA_PX = 50;
const ENGINE_ICONS = {
    yandex: '/i/logos/ya.webp',
    google: '/i/logos/google.webp',
    zen: '/i/logos/dzen.webp',
};

function parseJsonAttribute(element, attributeName, fallback) {
    const rawValue = element.getAttribute(attributeName);

    if (!rawValue) {
        return fallback;
    }

    try {
        return JSON.parse(rawValue);
    } catch (error) {
        return fallback;
    }
}

function setCookie(name, value) {
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; path=/';
}

function getHintKey(baseName, engine, promoHints) {
    if (baseName === 'gny') {
        return promoHints.gny;
    }

    return promoHints[engine] || promoHints.yandex;
}

function fetchHeroSuggestions(apiUrl, query, baseName) {
    const url = apiUrl + '/suggestion/domain_and_keyword'
        + '?query=' + encodeURIComponent(query)
        + '&base=' + encodeURIComponent(baseName);

    // Без кастомных заголовков — простой CORS GET, без OPTIONS preflight
    return fetch(url, {
        credentials: 'include',
    })
        .then(function (response) {
            if (!response.ok) {
                throw new Error('Suggestion request failed');
            }

            return response.json();
        })
        .then(function (payload) {
            if (Array.isArray(payload)) {
                return payload;
            }

            if (payload && Array.isArray(payload.data)) {
                return payload.data;
            }

            return [];
        })
        .catch(function () {
            return [];
        });
}

function updateInputPadding(input, databaseContainer) {
    if (!input) {
        return;
    }

    if (!databaseContainer) {
        input.style.paddingRight = '';
        return;
    }

    input.style.paddingRight = (databaseContainer.clientWidth + 17) + 'px';
}

function initHeroSearchDatabase(form, onDatabaseChange) {
    const dbRoot = form.querySelector('[data-hero-search-db]');
    const dbToggle = form.querySelector('[data-hero-search-db-toggle]');
    const dbPanel = form.querySelector('[data-hero-search-db-panel]');
    const dbFilter = form.querySelector('[data-hero-search-db-filter]');
    const dbEmpty = form.querySelector('[data-hero-search-db-empty]');
    const dbOptions = form.querySelectorAll('[data-hero-search-db-option]');
    const dbInput = form.querySelector('[data-hero-search-db-input]');
    const dbLabel = form.querySelector('[data-hero-search-db-label]');
    const dbIcon = form.querySelector('[data-hero-search-db-icon]');

    if (!dbRoot || !dbToggle || !dbPanel || !dbInput) {
        return {
            getCurrentBaseName: function () {
                return form.getAttribute('data-current-db') || '';
            },
        };
    }

    const locale = form.getAttribute('data-locale') || '';
    // Как в исходном GuestPromoSearchDatabase: открытие по наведению
    const HOVER_CLOSE_MS = 100;
    const HOVER_SKIP_MS = 300;
    let hoverCloseTimer = null;
    let skipHover = false;

    function canUseHover() {
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function isOpen() {
        return !dbPanel.hidden;
    }

    function filterOptions() {
        const query = (dbFilter ? dbFilter.value : '').trim().toLowerCase();
        let visibleCount = 0;

        dbOptions.forEach(function (option) {
            const caption = (option.getAttribute('data-caption') || option.textContent || '').toLowerCase();
            const short = (option.getAttribute('data-short') || '').toLowerCase();
            const name = (option.getAttribute('data-name') || '').toLowerCase();
            const matches = !query || caption.indexOf(query) !== -1 || short.indexOf(query) !== -1 || name.indexOf(query) !== -1;
            const item = option.closest('li');

            if (item) {
                item.hidden = !matches;
            } else {
                option.hidden = !matches;
            }

            if (matches) {
                visibleCount += 1;
            }
        });

        if (dbEmpty) {
            dbEmpty.hidden = visibleCount > 0;
        }
    }

    function closePanel() {
        clearTimeout(hoverCloseTimer);
        dbPanel.hidden = true;
        dbRoot.classList.remove('is-open');
        dbToggle.setAttribute('aria-expanded', 'false');

        if (dbFilter) {
            dbFilter.value = '';
            filterOptions();
        }
    }

    function alignPanel() {
        dbPanel.style.left = '0';
        dbPanel.style.right = 'auto';

        const rect = dbPanel.getBoundingClientRect();
        if (rect.right > window.innerWidth - 8) {
            dbPanel.style.left = 'auto';
            dbPanel.style.right = '0';
        }
    }

    function openPanel() {
        dbPanel.hidden = false;
        dbRoot.classList.add('is-open');
        dbToggle.setAttribute('aria-expanded', 'true');
        filterOptions();
        alignPanel();
    }

    function selectDatabase(option) {
        const name = option.getAttribute('data-name') || '';
        const engine = option.getAttribute('data-engine') || '';
        const short = option.getAttribute('data-short') || '';

        if (!name) {
            return;
        }

        if (engine === 'zen') {
            window.location.assign('/' + locale + '/dzen');
            return;
        }

        dbInput.value = name;
        form.setAttribute('data-current-db', name);
        setCookie('dbname', name);

        if (engine) {
            setCookie('engine', engine);
        }

        if (dbLabel) {
            dbLabel.textContent = short;
        }

        if (dbIcon) {
            dbIcon.src = ENGINE_ICONS[engine] || ENGINE_ICONS.yandex;
        }

        dbOptions.forEach(function (item) {
            const isActive = item === option;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        skipHover = true;
        closePanel();
        setTimeout(function () {
            skipHover = false;
        }, HOVER_SKIP_MS);
        onDatabaseChange(name, engine);
    }

    dbRoot.addEventListener('pointerenter', function () {
        if (!canUseHover() || skipHover) {
            return;
        }

        clearTimeout(hoverCloseTimer);
        openPanel();
    });

    dbRoot.addEventListener('pointerleave', function () {
        if (!canUseHover()) {
            return;
        }

        hoverCloseTimer = setTimeout(closePanel, HOVER_CLOSE_MS);
    });

    dbToggle.addEventListener('click', function (event) {
        event.preventDefault();

        if (canUseHover()) {
            if (!isOpen()) {
                openPanel();
            }
            return;
        }

        if (isOpen()) {
            closePanel();
        } else {
            openPanel();
        }
    });

    if (dbFilter) {
        dbFilter.addEventListener('input', filterOptions);
        dbFilter.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                closePanel();
                dbToggle.focus();
            }
        });
    }

    dbOptions.forEach(function (option) {
        option.addEventListener('click', function () {
            selectDatabase(option);
        });
    });

    document.addEventListener('click', function (event) {
        if (!dbRoot.contains(event.target)) {
            closePanel();
        }
    });

    return {
        getCurrentBaseName: function () {
            return dbInput.value || form.getAttribute('data-current-db') || '';
        },
        getDatabaseContainer: function () {
            return dbRoot;
        },
    };
}

function initHeroSearch(form) {
    if (form.getAttribute('data-hero-search-initialized') === '1') {
        return;
    }

    const input = form.querySelector('[data-hero-search-input]');
    const suggestionsPanel = form.querySelector('[data-hero-search-suggestions]');
    const suggestionsList = form.querySelector('[data-hero-search-suggestions-list]');
    const hintDomain = form.querySelector('[data-hero-search-hint-domain]');
    const hintKeyword = form.querySelector('[data-hero-search-hint-keyword]');

    if (!input || !suggestionsPanel || !suggestionsList) {
        return;
    }

    form.setAttribute('data-hero-search-initialized', '1');

    const promoHints = parseJsonAttribute(form, 'data-promo-hints', {});
    const apiUrl = (form.getAttribute('data-api-url') || '').replace(/\/$/, '');

    let suggestions = [];
    let allowSuggestion = true;
    let suggestionTimer = null;
    let activeSuggestionIndex = -1;

    function hideSuggestions() {
        suggestionsPanel.hidden = true;
        suggestionsList.innerHTML = '';
        suggestions = [];
        activeSuggestionIndex = -1;
    }

    const databaseControls = initHeroSearchDatabase(form, function (baseName, engine) {
        updateHints(baseName, engine);
        refreshInputPadding();
        hideSuggestions();

        if (allowSuggestion) {
            scheduleSuggestions();
        }
    });

    function getCurrentBaseName() {
        return databaseControls.getCurrentBaseName();
    }

    function refreshInputPadding() {
        updateInputPadding(input, databaseControls.getDatabaseContainer ? databaseControls.getDatabaseContainer() : null);
    }

    function updateHints(baseName, engine) {
        const hints = getHintKey(baseName, engine, promoHints);

        if (!hints) {
            return;
        }

        if (hintDomain) {
            hintDomain.textContent = hints.domain || '';
        }

        if (hintKeyword) {
            hintKeyword.textContent = hints.keyword || '';
        }
    }

    function renderSuggestions() {
        suggestionsList.innerHTML = '';

        if (!suggestions.length) {
            hideSuggestions();
            return;
        }

        suggestions.forEach(function (suggestion, index) {
            const item = document.createElement('li');
            item.className = 'p-autocomplete-item font-light';
            item.setAttribute('role', 'option');
            item.textContent = suggestion;

            if (index === activeSuggestionIndex) {
                item.classList.add('p-highlight');
            }

            item.addEventListener('mousedown', function (event) {
                event.preventDefault();
            });

            item.addEventListener('click', function () {
                allowSuggestion = false;
                input.value = suggestion;
                hideSuggestions();
                form.requestSubmit();
            });

            suggestionsList.appendChild(item);
        });

        suggestionsPanel.hidden = false;
    }

    function scheduleSuggestions() {
        clearTimeout(suggestionTimer);

        const baseName = getCurrentBaseName();

        if (!allowSuggestion || !apiUrl || !baseName) {
            return;
        }

        const query = input.value.trim();

        if (!query || query.length < SEARCH_LENGTH_LOAD_DATA) {
            hideSuggestions();
            return;
        }

        suggestionTimer = setTimeout(function () {
            fetchHeroSuggestions(apiUrl, query, baseName)
                .then(function (response) {
                    suggestions = response;
                    activeSuggestionIndex = -1;
                    renderSuggestions();
                });
        }, SEARCH_DELAY_LOAD_DATA);
    }

    function fillSearch(value) {
        const normalizedValue = (value || '').trim();

        if (!normalizedValue) {
            return;
        }

        input.value = normalizedValue;
        allowSuggestion = true;
        scheduleSuggestions();
        input.focus();
    }

    input.addEventListener('input', function () {
        allowSuggestion = true;
        scheduleSuggestions();
    });

    input.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
            hideSuggestions();
            form.requestSubmit();
            return;
        }

        if (!suggestions.length || suggestionsPanel.hidden) {
            return;
        }

        if (event.key === 'ArrowDown') {
            event.preventDefault();
            activeSuggestionIndex = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
            renderSuggestions();
        }

        if (event.key === 'ArrowUp') {
            event.preventDefault();
            activeSuggestionIndex = Math.max(activeSuggestionIndex - 1, 0);
            renderSuggestions();
        }

        if (event.key === 'Escape') {
            hideSuggestions();
        }
    });

    form.addEventListener('submit', function (event) {
        if (!input.value.trim()) {
            event.preventDefault();
        }
    });

    if (hintDomain) {
        hintDomain.addEventListener('click', function () {
            fillSearch(hintDomain.textContent);
        });
    }

    if (hintKeyword) {
        hintKeyword.addEventListener('click', function () {
            fillSearch(hintKeyword.textContent);
        });
    }

    const tryLink = form.querySelector('[data-hero-search-try]');

    if (tryLink) {
        tryLink.addEventListener('click', function (event) {
            event.preventDefault();

            const target = document.getElementById('block-free-tools');

            if (!target) {
                return;
            }

            const menuHeight = parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--keysso-top-menu-height')
            ) || 57;

            window.scrollTo({
                top: target.getBoundingClientRect().top + window.scrollY - menuHeight - TRY_SCROLL_EXTRA_PX,
                behavior: 'smooth',
            });
        });
    }

    document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) {
            hideSuggestions();
        }
    });

    refreshInputPadding();
    window.addEventListener('resize', refreshInputPadding);
}

function initHeroSearches() {
    document.querySelectorAll('[data-hero-search]').forEach(initHeroSearch);
}

function init() {
    initHeroSearches();
    initLandingVideo();
    initReviews();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
